import { createUseStyles } from 'react-jss'
import { colors } from '..'

const useFileTileStyles = createUseStyles({
  fileTileWrapper: {
    position: 'relative',
    width: 90,
    height: 90,
    backgroundColor: colors.gray200,
    color: colors.gray600,
    margin: '0.5rem 0.5rem 0 0',
    borderRadius: '4px',
    userSelect: 'none',

    '& > .filename': {
      position: 'absolute',
      width: '100%',
      bottom: 0,
      padding: '0 5px',
      textAlign: 'center',
      fontSize: 14,
      color: '#fff',
      backgroundColor: colors.gray600,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    '& > .upload-file': {
      position: 'absolute',
      width: '100%',
      bottom: 5,
      textAlign: 'center',
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    '& > .icon.remove': {
      position: 'absolute',
      display: 'none',
      padding: 5,
      top: 0,
      right: 0,
      cursor: 'pointer'
    },

    '&:hover > .icon.remove': {
      display: 'block'
    },

    '& > input[type=file]': {
      position: 'absolute',
      top: -999,
      left: -999,
      opacity: 0,
      overflow: 'hidden',
      zIndex: -1
    },

    '&.upload': {
      background: 0,
      border: `2px dashed ${colors.gray600}`,

      '&:hover': {
        borderColor: colors.theme500,
        color: colors.theme500,
        cursor: 'pointer'
      }
    }
  }
})

const useUploadStyles = createUseStyles({
  uploadWrapper: {
    margin: '1rem'
  }
})

export { useUploadStyles, useFileTileStyles }
